import MDBox from "components/MDBox"
import LinearProgress from '@material-ui/core/LinearProgress';

export default function CTLLinearProgress({  isLoading }) {
    if (!isLoading) return null;
    return (
        <MDBox style={{ height: "3px" }}>
            <LinearProgress color="primary" />
        </MDBox>
    )
}